import { Col } from '../Col'
import { Divider } from '../Divider'
import { Row } from '../Row'
import { Button } from '../Button'
import { ReactNode } from 'react'

interface ContentHeaderProps {
  children: ReactNode
}

export const ContentHeader = (props: ContentHeaderProps) => {
  const { children } = props

  return (
    <div>
      <Row>
        <Col span={12}>
          <h1>{children}</h1>
        </Col>
        <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="primary" />
        </Col>
      </Row>
      <Divider />
    </div>
  )
}

export default ContentHeader
